import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateJurisdictionResourceMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  changes: Types.Jurisdiction_Resources_Set_Input;
}>;


export type UpdateJurisdictionResourceMutation = { __typename?: 'mutation_root', update_jurisdiction_resources_by_pk?: { __typename?: 'jurisdiction_resources', id: any } | null };


export const UpdateJurisdictionResourceDocument = gql`
    mutation updateJurisdictionResource($id: uuid!, $changes: jurisdiction_resources_set_input!) {
  update_jurisdiction_resources_by_pk(pk_columns: {id: $id}, _set: $changes) {
    id
  }
}
    `;
export type UpdateJurisdictionResourceMutationFn = Apollo.MutationFunction<UpdateJurisdictionResourceMutation, UpdateJurisdictionResourceMutationVariables>;

/**
 * __useUpdateJurisdictionResourceMutation__
 *
 * To run a mutation, you first call `useUpdateJurisdictionResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJurisdictionResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJurisdictionResourceMutation, { data, loading, error }] = useUpdateJurisdictionResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useUpdateJurisdictionResourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJurisdictionResourceMutation, UpdateJurisdictionResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJurisdictionResourceMutation, UpdateJurisdictionResourceMutationVariables>(UpdateJurisdictionResourceDocument, options);
      }
export type UpdateJurisdictionResourceMutationHookResult = ReturnType<typeof useUpdateJurisdictionResourceMutation>;
export type UpdateJurisdictionResourceMutationResult = Apollo.MutationResult<UpdateJurisdictionResourceMutation>;
export type UpdateJurisdictionResourceMutationOptions = Apollo.BaseMutationOptions<UpdateJurisdictionResourceMutation, UpdateJurisdictionResourceMutationVariables>;